export default "<p>\n  facility works!\n</p>\n";